import { TournamentPlan } from 'modules/organizer/domain/interfaces/tournament-plan';

export interface TournamentPlanDto {
  id: number;
  name: string;
  priceInMinorUnits: number;
  period: TournamentPlan['period'];
}

export function mapTournamentPlan(dto: TournamentPlanDto): TournamentPlan {
  return {
    id: dto.id,
    name: dto.name,
    priceInMinorUnits: dto.priceInMinorUnits,
    period: dto.period,
  };
}
